var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5023 12.1158V10.962C12.5023 10.35 12.2591 9.76298 11.8263 9.3302C11.3936 8.89743 10.8066 8.6543 10.1946 8.6543H5.57918C4.96714 8.6543 4.38017 8.89743 3.94739 9.3302C3.51462 9.76298 3.27148 10.35 3.27148 10.962V12.1158",
    stroke: "#364A63",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88777 6.34586C9.16228 6.34586 10.1955 5.31267 10.1955 4.03816C10.1955 2.76366 9.16228 1.73047 7.88777 1.73047C6.61327 1.73047 5.58008 2.76366 5.58008 4.03816C5.58008 5.31267 6.61327 6.34586 7.88777 6.34586Z",
    stroke: "#364A63",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.c435b72dbdd90013ab99d47f617810f3.svg";
export { ForwardRef as ReactComponent };